export default "__VITE_ASSET__ea46d6e5__"